import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import '../public/static/css/global.css'
import './assets/icon/iconfont.css'
import './assets/css/tailwind.css'
import adminApi from './util/common.js';
import { Icon } from '@iconify/vue2';
Vue.component('IconifyIcon', Icon);

Vue.config.productionTip = false

Vue.use(ElementUI);

//定义全局变量
Vue.prototype.adminApi = adminApi;
import axios from 'axios';
// 请求基准路径
// axios.defaults.baseURL = adminApi.admin_api;


router.beforeEach((to, from, next) => {
  // 判断下当前页面的地址如果是 /query/cert 则，不用调整手机端
  if (window.location.pathname.indexOf('/query/cert') !== -1) {
    next();
    return;
  }

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // 鸿蒙 HarmonyOS / OpenHarmony 的 UA 不含 android，需要单独识别
  const isMobileUA = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini|harmonyos|openharmony/i.test(userAgent);
  // iPadOS 13+ 的 Safari 会伪装成 Mac，需要结合触控能力识别
  const isIpadOS = /Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1;
  // 兜底：微信 / 手机浏览器内嵌 webview 一般都有 MicroMessenger / Mobile 关键字
  const isWeixinMobile = /MicroMessenger/i.test(userAgent) && /Mobile/i.test(userAgent);
  if (isMobileUA || isIpadOS || isWeixinMobile) {
    // 是移动端，跳转到手机站
    window.location.href = 'https://www.yktexam.cn/m';
    return;
  }
  // 是PC端，继续正常的导航
  next();
});


var https = axios.create({
  baseURL: adminApi.admin_api,
  timeout: 5000,
});

// 请求拦截（配置发送请求的信息）-------------------
https.interceptors.request.use(function (config) {
  // 处理请求之前的配置
  const token = sessionStorage.getItem('access-token');
  var is_login = config.url.indexOf('login') == -1 ? false : true;
  if (!is_login) {
    // 添加token到headers
    if (token) {
      //config.headers.Authorization = token;
      config.headers.Authorization = 'Bearer ' + token;
    }
  }
  return config;
}, function (error) {
  // 请求失败的处理
  return Promise.reject(error);
});

// 响应拦截（配置请求回来的信息）-------------------
https.interceptors.response.use((response) => {
  if (response.data) {
    if (response.data.code == 401) {
      router.push('/');
    } else {
      return response.data
    }
  } else {
    return response.data;
  }
}, function (error) {
  // 处理响应失败
  return Promise.reject(error);
});
Vue.prototype.axios = https;
document.title = "亿考通学员端考试系统"
//路由守卫
// router.beforeEach((to, from, next) => {
//   document.title = "安徽省六安市舒城智慧园区管理与服务平台"
//   if (to.path === '/Login') return next()
//   const token = sessionStorage.getItem('access-token')
//   if (!token) return next('/Login')
//   next()
// })

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
